import {createAction} from '@reduxjs/toolkit';
export const toggleMinimapDisplay = createAction('minimap/toggle');